import { Toast } from 'utils/toast'

import { Post } from 'types/post'
import { Program } from 'types/program'

export const showPendingMembershipSuccess = (post: Post, program: Program) => {
  Toast.success(
    `Let's Go!`,
    `You just requested to join ${
      program.title ?? `${post?.creator.firstName} ${post?.creator.lastName}'s Group`
    }`,
    undefined,
    {},
    true,
    'bottom',
  )
}
